<template>
  <admin-only redirectOnNotAuthorized>
    <v-container fluid>
      <v-toolbar color="white">
          <h2 class="headline ml-5"> <v-icon>mdi-car</v-icon> Fahrzeuge</h2>
      </v-toolbar>
          <v-btn
              class="mt-4"
              color="success"
              large
              @click="addMachine"
          >
            <v-icon>mdi-car</v-icon>
            Fahrzeug/Gerät hinzufügen
          </v-btn>
      <div class="d-flex align-center">
        <v-text-field v-model="filter" clearable label="Suche" prepend-icon="mdi-magnify" hide-details style="max-width: 250em"></v-text-field>
        <v-spacer/>
        <span class="subtitle-2 ml-4 mr-2">Filter:</span>
        <v-btn-toggle v-model="statusFilter" multiple tile group color="blue accent-3" class="ml-4">
          <v-btn value="active">Aktiv</v-btn>
          <v-btn value="inactive">Inaktiv</v-btn>
        </v-btn-toggle>
        <v-spacer/>
      </div>
      <v-expansion-panels class="mt-2" multiple>
        <v-expansion-panel v-for="machine in filteredMachines" :key="machine.id">
          <v-expansion-panel-header :class="{ 'content-with-description': !!machine.description }">
            <div class="d-flex justify-space-between align-center">
              <h3>{{ machine.displayName }} <span class="text--disabled font-italic" v-if="!machine.isActive">- Inaktiv</span></h3>
              <v-btn icon @click.stop="editMachine(machine)"><v-icon>mdi-pencil</v-icon></v-btn>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-if="machine.description" class="mb-4 text-pre-wrap text--secondary">{{ machine.description }}</div>
            <span v-if="machine.isToolThatCanBeUsedWithAnyMachine">Kann ohne einem Fahrzeug verwendet werden.</span>
            <v-data-table
                v-else
                :items="getFiltered(machine.tools)"
                :headers="[{ text: 'Gerät', value: 'displayName' }, { text: 'Beschreibung', value: 'description' }]"
                disable-sort
                hide-default-footer
                :items-per-page="-1"
                :item-class="getInactiveClass"
                @click:row="editTool(machine, $event)"
            >
              <template #item.displayName="{ item:tool }">
                {{tool.displayName}} <span v-if="!tool.isActive" class="font-italic text--disabled">- Inaktiv</span>
              </template>
              <template #footer>
                <v-btn text @click="addTool(machine)"><v-icon>mdi-plus-box</v-icon> Gerät hinzufügen</v-btn>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <machine-dialog
      :open.sync="showMachineModal"
      :machine="selectedMachine"
      @close="closeMachineModal"
    />
    <tool-dialog
      :open.sync="showToolModal"
      :tool="selectedTool"
      :machineId="selectedMachineId"
      @close="closeToolModal"
    />
  </admin-only>
</template>

<script>
import { mapState } from "vuex";
import ToolDialog from './projekte/ToolDialog';
import MachineDialog from "@/components/projekte/MachineDialog";

function nameIncludes(entry, query) {
  return entry.displayName.toLowerCase().includes(query);
}

export default {
  name: 'Fahrzeuge',
  components: {
    MachineDialog,
    ToolDialog,
  },
  computed: {
    ...mapState(['machines']),
    filteredMachines() {
      const query = this.filter ? this.filter.toLowerCase() : null;

      return this.machines.filter(x => this.statusFilterIncludes(x) && (!query || nameIncludes(x, query) || x.tools.some(t => nameIncludes(t, query))));
    },
    selectedMachineId() {
      return this.selectedMachine ? this.selectedMachine.id : null;
    },
  },
  methods: {
    statusFilterIncludes(element) {
      const toolsInclude = !!element.tools && element.tools.some(this.statusFilterIncludes);
      return toolsInclude ||
          (this.statusFilter.includes('active') && element.isActive) ||
          (this.statusFilter.includes('inactive') && !element.isActive);
    },
    getFiltered(elements) {
      return elements ? elements.filter(this.statusFilterIncludes) : elements;
    },
    getInactiveClass(element) {
      return element.isActive ? ''
          : 'font-italic text--disabled';
    },
    editMachine(machine) {
      this.selectedMachine = machine;
      this.showMachineModal = true;
    },
    editTool(machine, tool) {
      this.selectedMachine = machine;
      this.selectedTool = tool;
      this.showToolModal = true;
    },
    addMachine() {
      this.showMachineModal = true;
    },
    addTool(machine) {
      this.selectedMachine = machine;
      this.showToolModal = true;
    },
    closeToolModal() {
      this.selectedMachine = null;
      this.selectedTool = null;
      this.showToolModal = false;
    },
    closeMachineModal() {
      this.showMachineModal = false;
      this.selectedMachine = null;
    }
  },
  data: () => ({
    filter: null,
    statusFilter: [ 'active', 'inactive' ],
    showMachineModal: false,
    showToolModal: false,
    selectedMachine: null,
    selectedTool: null,
  }),
};
</script>
<style lang="scss">
  .content-with-description.v-expansion-panel-header--active {
    padding-bottom: 0;
  }
</style>
